import types from "../constans";

const initialState = {
    availableEvents: [],
    error: null,
    eventLoading: false,
    isLoadedContainer: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_EVENTS_LOADING:
            return {
                ...state,
                eventLoading: true
            }
        case types.SET_EVENTS_DATA:
            return {
                ...state,
                availableEvents: action.payload,
                eventLoading: false
            };
        case types.SET_EVENT_ERROR_RESPONSE:
            return {
                ...state,
                error: action.payload,
                eventLoading: false
            };
        case types.SET_LOADED_CONTAINER:
            return {
                ...state,
                isLoadedContainer: action.isLoaded,
            };
        default:
            return state
    }
}
